import React, { useEffect } from "react";
import { useState } from "react";
import { useQuery } from "@apollo/client";
import ViewImage from "../Student/ViewImage";
import EmptyData from "../Include/EmptyData";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../Include/LoadingPage";
import { GET_REQUEST_TRANSACTION } from "../../Schema/Enrollment";
import { Box, Stack, Typography, IconButton } from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';


export default function RequestAllowClass() {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const { refetch } = useQuery(GET_REQUEST_TRANSACTION, {
    variables: {
      type: "Account"
    },
    onCompleted: ({ getRequestTransaction }) => { 
      console.log("getRequestTransaction ===> ", getRequestTransaction)
      setLoading(false);
      setTableData(getRequestTransaction);
    },
    onError: (error) => {
      console.log(error.message)
    }
  })

  useEffect(() => {
    refetch();
  }, []);


  return (
    <>
      <Box className="employee-chart">
        <Stack direction="column" spacing={2}>

          <Typography className="chart-title" sx={{ color: "#0f81c2" }}>
            Request not allow
          </Typography>

          <Stack spacing={1}>
            {
              loading ? (<LoadingPage />) :
                tableData?.length === 0 ? (<EmptyData />) :
                  tableData?.map((e) => (
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                      <Stack>
                        <ViewImage
                          id={e?.studentId?._id}
                          stuName={e?.studentId?.lastName + " " + e?.studentId?.firstName}
                          src={e?.studentId?.profileImg?.slice(0, 5) === "https" ? e?.studentId?.profileImg : `${process.env.REACT_APP_VIEW_URL}${e?.studentId?.profileImg}`}
                        /> 
                      </Stack>
                      <Typography>
                          { e?.classId?.gradeId?.gradeName+" "+e?.classId?.className }
                      </Typography>

                      <IconButton onClick={() => navigate(`/students/student-detail?studentId=${e?.studentId?._id}`)} sx={{ color: "#0f81c2" }}>
                        <ArrowForwardIosIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                  ))
            }
          </Stack>
        </Stack>

      </Box>
    </>
  );
}
